export default __webpack_public_path__ + "static/media/email-pending-footer-illustration.84863570.svg";